/**
 * 广告 接口的统一出口
 */
import axios from '.././http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来

const api = '/c-api/';

const mediaShare = {
    // 列表
    sharemedialist(params) {
        return axios.get(api + 'media/sharemedialist', {params: params});
    },
    // 获取面包屑
    sharebreadcrumblist(params) {
        return axios.get(api + 'media/sharebreadcrumblist', {params: params});
    },
    // 创建分享链接
    createsharelink(params) {
        return axios.post(api + 'media/createsharelink', qs.stringify(params))
    },
    // 验证提取码
    checksharecode(params) {
        return axios.post(api + 'media/checksharecode', qs.stringify(params))
    },
    // 下载
    downloadsharemedialink(params) {
        return axios.post(api + 'media/downloadsharemedialink', qs.stringify(params))
    },
}


// 导出接口
export default mediaShare